// extracted by mini-css-extract-plugin
export var paginationContainer = "_77-0";